<template>
  <div>

  <v-layout  v-if="!dataLoaded" justify-center align-center style="height: 100%;width: 100%;position: absolute;">
    <v-progress-circular
        :size="64"
        indeterminate
        color="primary">
    </v-progress-circular>
  </v-layout> 
    
    <v-form v-if="dataLoaded" ref="inputForm" @submit.prevent="">
      <v-container v-if="step == 1" px-10 fill-height ms-auto class="containerMaxWidth">
        
        <v-stepper non-linear>
          <div class="c-stepper__header">
            <div tabindex="-1" class="c-stepper__step">
                <span class="c-stepper__step__step primary"><v-icon  icon="icon" color="white">mdi-account-check</v-icon></span>
              <div class="c-stepper__label">{{ $let('Eligible_SectionTitle') }}</div>
            </div>
          </div>
        </v-stepper>
        
        <v-row no-gutters>
          <v-col>
            <v-sheet color="white" class="custom-shadow pa-10">  
              
              <!-- EligibleSection -->
              <div v-html="$let('Eligible_SectionTitle')" class="subtitle-enquiry transition-swing mb-5"></div>

              <v-row class="col6__px" no-gutters>
                
                <v-col cols="12" sm="12" md="6">
                  <Currency
                    v-model="model.incomeAmount" 
                    :label="$let('Eligible_IncomeLabel')"
                    :rules="[validationRules.numeric, validationRules.required, validationRules.notZero]"
                    :keyup_enter="_checkEligibilityClick"
                    :options="currencyOptions">
                  </Currency>
                </v-col>
                
                <v-col cols="12" sm="12" md="6">
                  <Currency
                    v-model="model.outgoingAmount" 
                    :label="$let('Eligible_ExpenditureLabel')"
                    :rules="[validationRules.numeric, validationRules.required]"
                    :keyup_enter="_checkEligibilityClick"
                    :options="currencyOptions">
                  </Currency>
                </v-col>
                
              </v-row>

              <StepperButtons
                :backAvailable="false"
                @continueClick="_checkEligibilityClick">
              </StepperButtons>
            </v-sheet>
          </v-col>  
        </v-row>
      </v-container>
        
      <v-container v-if="step == 2" pa-0 fill-height ms-auto class="pop-container">  
        <v-row no-gutters>
          <v-col>
            
            <!-- EligibleResult -->
            <v-sheet color="white" class="custom-shadow eligibleResult pa-10 overflow-hidden">

            <v-sheet color="text--text" class="text-center" v-html="eligibleResultText"></v-sheet>

            <div style="text-align:center;">
              <StepperButtons
                :continueAvailable="model.eligible"
                @continueClick="_continueButtonClick"
                @backClick="_backButtonClick" >
              </StepperButtons>
            </div>

            </v-sheet>

          </v-col>  
        </v-row>
      </v-container>
    </v-form>

    <LoadingOverlay
      :show="inAction">
    </LoadingOverlay>

  </div>
</template>

<script>

  import { mapActions } from "vuex";
  import Currency from '@/shared/components/currency.vue';
  import StepperButtons from '../components/stepper-buttons.vue';
  import LoadingOverlay from '@/shared/components/loading-overlay.vue'

  import validators from '@/shared/utils/validators.js';
  import generic from '@/shared/utils/generic.js';
  import opmGeneric from '../utils/generic.js';
  import constants from '../constants/generic.js';
  import router from '../router';
  import routerNames from '../router/router-names';
  import paramKeys from '../constants/param-keys.js';

  export default {
    name: 'Eligible',
    components: {
      Currency, 
      StepperButtons,
      LoadingOverlay,
    },
    props: {
      dataLoaded: { type: Boolean, default: false },
    },
    data() {
      return {
        step: 1,
        validationRules: validators.validationRules(),
        eligibleResultText: '',
        inAction: false,
        currencyOptions: opmGeneric.currencyConfig(),
        model: {
          loanRepayment: window._inputs.inputModule.loanRepayment,
          loanRepaymentFrequency: window._inputs.inputModule.loanFrequency,
          incomeAmount: undefined,
          outgoingAmount: undefined,
          eligible: undefined,
        }, 
      };
    },
    watch: {
      dataLoaded: {
        immediate: true,
        handler(value) {
          
          if (value) {
          
            // Reset validationRules with locale texts
            // Because Eligible is the first view we must wait for all data to be loaded to access displayTexts
            const validatorTexts = { 
              reqFld: this.$let('RequiredFieldEmptyMessage'), 
              invValue: this.$let('InvalidValue')
            };
            this.validationRules = validators.validationRules(validatorTexts);

            // Check EligibilityCheckEnabled
            const eligibilityEnabled = generic.paramValue(this.$store, paramKeys.EligibilityCheckEnabled).toBool();
            if (!eligibilityEnabled) {
              this.model.eligible = true;
              this.updateLocalLoanEnquiryData(this.model);
              router.push({ name: routerNames.MemberNonMember });
            }
          }
        }
      }
    },
    mounted() {
      
      if (this.$store.state.loanEnquiryData.eligible !== undefined) {      
        this.model = this.$store.state.loanEnquiryData;
        this.parseEligibility(this.model.eligible);
      }
    },
    methods: {
      ...mapActions(["checkEligibility", "updateLocalLoanEnquiryData"]),

      _continueButtonClick() {
        router.push({ name: routerNames.MemberNonMember });
      },

      _backButtonClick() { 
        window.scrollTo({ top: 0 });
        this.step--;
      },

      async _checkEligibilityClick() {
        if (this.$refs.inputForm.validate()) {
          this.inAction = true;
          const resp = await this.checkEligibility(this.model);
          if (resp) {
            this.parseEligibility(resp.Response.StatusCode === constants.LOAN_ENQUIRY_SUCCESS && resp.Eligibility);
            this.step++;
            this.inAction = false;
          }
        }
      },

      parseEligibility(isEligible) {
        this.model.eligible = isEligible;
        this.updateLocalLoanEnquiryData(this.model);
        this.eligibleResultText = this.$let(isEligible ? 'Eligible_EligibleApplyant' : 'Eligible_NotEligibleApplyant');
      }
    },
  };
</script>